import { motion } from "framer-motion";
import { IMG } from "@/data/site";

const MARKERS = [
  { x: "38%", y: "20%" },
  { x: "46%", y: "38%" },
  { x: "42%", y: "58%" },
  { x: "53%", y: "76%" },
];

export default function LiveSessionCard() {
  return (
    <div
      data-testid="live-session-card"
      className="relative overflow-hidden border border-white/10 bg-coal shadow-[0_30px_90px_-30px_rgba(37,99,235,0.4)]"
    >
      <img
        src={IMG.deadlift}
        alt="Client performing a coached lift during a live StrengthLeap video session"
        loading="lazy"
        className="aspect-[4/5] w-full object-cover opacity-90"
      />

      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.12] [background-image:linear-gradient(rgba(59,130,246,0.7)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.7)_1px,transparent_1px)] [background-size:56px_56px]"
      />

      <svg aria-hidden="true" className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polyline
          points="38,20 46,38 42,58 53,76"
          fill="none"
          stroke="#3B82F6"
          strokeWidth="0.4"
          strokeDasharray="1.5 1.5"
          opacity="0.8"
        />
      </svg>
      {MARKERS.map((m, i) => (
        <motion.span
          key={i}
          aria-hidden="true"
          className="absolute h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-lime"
          style={{ left: m.x, top: m.y }}
          animate={{ opacity: [1, 0.25, 1] }}
          transition={{ duration: 2, repeat: Infinity, delay: i * 0.4 }}
        />
      ))}

      <div className="absolute left-4 top-4 flex items-center gap-2.5 border border-lime/40 bg-ink/70 px-3.5 py-2 backdrop-blur-md">
        <motion.span
          className="h-1.5 w-1.5 rounded-full bg-lime"
          animate={{ opacity: [1, 0.2, 1] }}
          transition={{ duration: 1.4, repeat: Infinity }}
        />
        <span className="font-mono text-[9px] uppercase tracking-[0.25em] text-white">
          Live 1:1 — form analysis
        </span>
      </div>

      <div className="absolute bottom-14 right-4 w-24 overflow-hidden border border-white/20 bg-ink sm:w-28">
        <img
          src={IMG.handstand}
          alt="StrengthLeap coach cueing live on camera"
          loading="lazy"
          className="aspect-[4/5] w-full object-cover"
        />
        <p className="bg-ink px-2 py-1.5 font-mono text-[8px] uppercase tracking-[0.2em] text-ash">
          Coach — on camera
        </p>
      </div>

      <div className="absolute inset-x-0 bottom-0 flex items-center justify-between border-t border-white/10 bg-ink/80 px-4 py-3 backdrop-blur-md">
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-ash">
          Cueing — hip hinge · bracing · tempo
        </p>
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-lime">00:24:16</p>
      </div>
    </div>
  );
}
